var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:['sidebar-container', {'is-collapse': _vm.isCollapse}]},[_vm._t("default",function(){return [_c('sidebar')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }